/** Must stay aligned with backend/config/subjectProfiles.js */

export const PET_SETUP_FIELDS = [
  { key: "Species", label: "Species", required: true, type: "text" },
  { key: "Breed", label: "Breed", type: "text" },
  { key: "Pet Age", label: "Age", type: "text" },
  { key: "Vaccination Information", label: "Vaccination details", type: "textarea" },
  { key: "Next Vaccination Date", label: "Next vaccination date", type: "date", reminder: true },
  { key: "Veterinarian Name", label: "Veterinarian name", type: "text" },
  { key: "Veterinarian Phone", label: "Veterinarian phone", type: "tel" },
  { key: "Emergency Contact Name", label: "Emergency contact name", required: true, type: "text" },
  { key: "Emergency Contact Phone", label: "Emergency contact phone", required: true, type: "tel" },
  { key: "Medical Notes (Allergies / Conditions)", label: "Medical notes", type: "textarea" },
];

export const VEHICLE_SETUP_FIELDS = [
  { key: "Vehicle Type", label: "Vehicle type", required: true, type: "text", placeholder: "Car, bike, scooter…" },
  { key: "Registration Number (RC)", label: "Registration number (RC)", required: true, type: "text" },
  { key: "Make & Model", label: "Make & model", type: "text" },
  { key: "Color", label: "Color", type: "text" },
  { key: "Insurance Provider", label: "Insurance provider", type: "text" },
  { key: "Insurance Policy Number", label: "Policy number", type: "text" },
  { key: "Insurance Expiry Date", label: "Insurance expiry", type: "date", reminder: true },
  { key: "Pollution Certificate Expiry", label: "Pollution (PUC) expiry", type: "date", reminder: true },
  { key: "Emergency Contact Name", label: "Emergency contact name", required: true, type: "text" },
  { key: "Emergency Contact Phone", label: "Emergency contact phone", required: true, type: "tel" },
];

export function fieldsForSubject(subjectType) {
  if (subjectType === "pet") return PET_SETUP_FIELDS;
  if (subjectType === "vehicle") return VEHICLE_SETUP_FIELDS;
  return [];
}
